exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mx-input{border:1px solid #28a745;color:#495057}.mx-input:focus,.mx-input:hover{border-color:#28a745}.mx-input:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.mx-icon-calendar{color:#28a745}.toggle .toggle-control{width:4em;border:2px solid #8e8e93;border-radius:2em;background-color:rgba(0,0,0,.06);position:relative}.toggle .toggle-control,.toggle .toggle-control:after{transition:.3s cubic-bezier(.95,.05,.795,.035);height:2em;display:block}.toggle .toggle-control:after{content:\"\";width:2em;background-color:#fff;border-radius:50%;box-shadow:0 1px 2px rgba(0,0,0,.4),0 3px 2px rgba(0,0,0,.4);position:absolute;top:-2px;left:0}.toggle input{display:none}.toggle input:checked+.toggle-control{border-color:#4cd964;background-color:#4cd964}.toggle input:checked+.toggle-control:after{left:2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a289a21a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/testimonial/Form.vue
// module id = 957
// module chunks = 0